import React, { Component } from 'react'
import './FormComplainCustomer.css'
import 'bootstrap/dist/css/bootstrap.min.css'

class FormComplainCustomer extends Component {
    render(){
        return(
            <div className="container">
                <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-4">
                        <input type="text" id="name" className="form-control" placeholder="Nombre(s)*" required/>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-4">
                        <input type="text" id="lastNameP" className="form-control" placeholder="Apellido Paterno*" required/>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-4">
                        <input type="text" id="lastNameM" className="form-control" placeholder="Apellido Materno*" required/>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-4">
                        <input type="email" id="email" className="form-control" placeholder="Email*" required/>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-4">
                        <input type="text" id="phoneNumber" className="form-control" placeholder="Teléfono*" required/>
                    </div>
                </div>
            </div>
        )
    }
}

export default FormComplainCustomer


// WEBPACK FOOTER //
// ./src/components/FormComplainCustomer/FormComplainCustomer.js